<template>
  <div class="conversation-list" :class="{
    'is-hidden': !isOpen,
  }">
    <ConversationItem v-for="item in conversationItems" :key="item.id" :item="item" />
    <div v-if="!allConversationsLoaded && conversationItemsCount && !isFetchingList" class="message--load-more">
      <button @click="fetchOldConversations">Load more...</button>
    </div>
    <div v-if="allConversationsLoaded && !conversationItemsCount && !isFetchingList"
      :class="['message--empty', $dm('text-slate-700', 'dark:text-slate-200')]">
      <p>No conversations found</p>
    </div>
    <div v-if="isFetchingList" class="message--loader">
      <spinner />
    </div>
  </div>
</template>

<script>
import Spinner from 'widget/components/Spinner.vue';
import darkModeMixin from 'widget/mixins/darkModeMixin.js';

import ConversationItem from "./ConversationItem.vue";

export default {
  name: "ConversationList",
  components: { ConversationItem, Spinner },
  mixins: [darkModeMixin],
  props: {
    status: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    conversationItems() {
      return this.$store.getters[`${this.status}ConversationList/getConversations`]
    },
    conversationItemsCount() {
      return this.$store.getters[`${this.status}ConversationList/getConversationCount`]
    },
    isFetchingList() {
      return this.$store.getters[`${this.status}ConversationList/getIsFetchingList`]
    },
    allConversationsLoaded() {
      return this.$store.getters[`${this.status}ConversationList/allConversationsLoaded`]
    },
    earliestConversation() {
      return this.$store.getters[`${this.status}ConversationList/getEarliestConversation`]
    },
  },
  mounted() {
    this.fetchOldConversations();
  },
  methods: {
    fetchOldConversations() {
      this.$store.dispatch(`${this.status}ConversationList/fetchOldConversations`, { before: this.earliestConversation.friendly_id }, { root: true });
    },
  }
};
</script>

<style scoped lang="scss">
@import "widget/assets/scss/helpers/variables.scss";

.conversation-list-container {
  .conversation-list {
    border-radius: 5px;
    font-size: 0.75rem;
  }
}

.message--loader {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.message--empty {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.message--load-more {
  display: flex;
  justify-content: center;
  margin: 10px 0;

  button {
    font-size: 16px;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
  }
}
</style>
